export default __webpack_public_path__ + "static/media/44_3_1.1378b5ff.png";